import React from 'react';
import get from 'lodash/get';

// Helpers
import { validEmail } from 'Shared/helpers';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useApp } from 'Shared/utils/hooks/use-app';

// Components
import { WpButton } from 'Wpds/components/button';
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';

// Styles
import './SsoSignInPage.scss';

const SsoSignInPage = () => {
  const [isSubmittingEmailForm, toggleIsSubmittingEmailForm] = useToggle(false);

  const {
    app: {
      routes: { ssoSignInUrl },
    },
  } = useApp();

  const csrfValue = get(document.getElementsByName('csrf-token')[0], 'content');

  const handleSubmit = () => toggleIsSubmittingEmailForm();

  const baseClassName = 'SsoSignInPage';
  return (
    <div className={baseClassName}>
      <h3 className={`${baseClassName}__title`}>Sign In with SSO</h3>
      <WpForm method="post" action={ssoSignInUrl} onSubmit={handleSubmit}>
        <WpFormLayout>
          <WpTextField
            name="email"
            id="user[email]"
            type="text"
            label="Work email"
            placeholder=""
            required
            validate={{
              isEmail: {
                callback: validEmail,
                error: 'Please enter a valid email.',
              },
            }}
            showRequiredIndicator={false}
            disabled={isSubmittingEmailForm}
            autoFocus
            autoComplete={false}
            qaTest="input-signin-email"
          />
        </WpFormLayout>
        <div style={{ visibility: 'hidden', height: '0px', position: 'absolute', top: '-1000px', left: '-1000px' }}>
          <WpTextField type="text" id="authenticity_token" label="authenticity_token" value={csrfValue} readOnly />
        </div>
        <WpButton
          size="lg"
          btnType="submit"
          block
          loading={isSubmittingEmailForm}
          qaTest="btn-sign-in-with-email-submit"
        >
          Continue
        </WpButton>
      </WpForm>
    </div>
  );
};

export default SsoSignInPage;
